import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { CheckboxComponent } from '@valk-nx/components/ui-checkbox/src/lib/checkbox';
import { cn } from '@valk-nx/core/lib/core';

import type { FiltersItemInterface } from '../../contracts/filters.interface';
import { collapsibleItems } from '../collapsible-items';
import { withAvailability } from '../filter-item-availability';
import { uniqueGroupName } from '../unique-group-name';

@Component({
	selector: `vp-filter-checkbox-group`,
	templateUrl: './filter-checkbox-group.html',
	host: { class: 'contents' },
	imports: [CheckboxComponent, TranslatePipe],
})
export class FilterCheckboxGroupComponent {
	title = input.required<string>();
	items = input<FiltersItemInterface[]>([]);
	itemsLimit = input.required<number>();
	activeValues = input<string[]>([]);

	changed = output<string[]>();

	protected readonly collapsible = collapsibleItems(
		this.items,
		this.itemsLimit,
	);

	protected readonly groupName = uniqueGroupName(this.title);

	protected readonly cn = cn;

	protected readonly options = computed(() =>
		withAvailability(this.collapsible.visibleItems(), this.activeValues()),
	);

	onToggle(value: string, keep: boolean): void {
		const activeValues = this.activeValues();

		this.changed.emit(
			keep
				? [...new Set([...activeValues, value])]
				: activeValues.filter((activeValue) => activeValue !== value),
		);
	}
}
